import { Fade, Grid, Typography } from '@mui/material';
import Popper, { PopperProps } from '@mui/material/Popper';
import { formatNumber } from '../../../pricing-simulator';
import { IProductMetric } from '../../../planner_v2/types/ppg-sku-drawer.model';

interface IMetricsPopperProps extends PopperProps {
  metrics: IProductMetric[];
}

export default function MetricsPopper({
  open,
  anchorEl,
  placement = 'right-end',
  metrics
}: IMetricsPopperProps) {
  return (
    <Popper
      sx={{
        maxHeight: '200px',
        maxWidth: '220px',
        boxShadow: (theme) => theme.shadows[5]
      }}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Grid
            container
            sx={{
              backgroundColor: '#F5F5F5',
              p: (theme) => theme.spacing(2, 1)
            }}
          >
            {metrics
              .slice()
              .sort((a, b) => a.display_order - b.display_order)
              .map((metric) => (
                <Grid key={metric.alias} mb={0.5} item xs={12} container>
                  <Grid item xs={6}>
                    <Typography
                      textAlign='right'
                      fontWeight={400}
                      color='#ACACAC'
                      fontSize='12px'
                    >
                      {metric.alias} :
                    </Typography>
                  </Grid>
                  <Grid item pl={1} xs={6}>
                    <Typography
                      textAlign='left'
                      fontWeight={400}
                      color='#3D3D3D'
                      fontSize='12px'
                    >
                      {formatNumber(
                        metric.metric_format,
                        metric.value,
                        metric.prefix,
                        metric.suffix
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Fade>
      )}
    </Popper>
  );
}
